import { Box, Flex, Text, customStyled } from '@mafc/trolly';
import { RoundCornerButton } from 'common/styled/Button.style';

export const HowOurFeesWork = customStyled(Flex)(({ theme: { fonts } }) => ({
  flexDirection: 'column',
  height: 'calc(100% - 72px)',
  fontFamily: fonts.montserrat,
}));

export const SurchargeText = customStyled(Flex)(({ theme: { colors, space } }) => ({
  margin: `0 auto ${space[4]}px auto`,
  maxWidth: '337px',
  color: colors.coffeeBlack,
}));

export const FeeTitle = customStyled(Box)(
  ({ theme: { colors, fontWeights, fontSizes, space } }) => ({
    display: 'inline',
    fontSize: fontSizes[2],
    fontWeight: fontWeights[5],
    marginRight: space[1],
    color: colors.black,
  })
);

export const FeeDescription = customStyled(Text.Caption)(({ theme: { colors, fontSizes } }) => ({
  fontSize: fontSizes[2],
  color: colors.coffeeBlack,
}));

export const IconWrapper = customStyled(Box)(({ theme: { space } }) => ({
  marginRight: space[3],
  maxWidth: '60px',
  width: '32%',
}));

export const FeeItem = customStyled(Flex)(({ theme: { space } }) => ({
  marginBottom: space[4],
}));

export const GoItButton = customStyled(RoundCornerButton)(({ theme: { space, fonts } }) => ({
  marginBottom: space[3],
  fontFamily: fonts.montserrat,
}));
